import FeeHelper from "../../utils/FeeHelper";
import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import classnames from "classnames";
import Switch from "@mui/material/Switch";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import useFeeStateHook from "../../hooks/useFeeStateHook";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

export const DealPageFee = ({fee, isLoading, isTabletOrMobile, isCappingDisabled, isEditingDisabled}) => {
    const [feeState, setFeeStateWithUpdate] = useFeeStateHook(fee)

    if (!feeState) return null;

    const isFinanced = feeState.is_capped
    const isNotEditable = !fee.is_editable

    return (
        <TableRow
            key={fee.id}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={'60%'}
                align="left"
            >
                {feeState.name}
            </TableCell>
            <TableCell
                className={'DealPageFee'}
                align="right"
                size={'small'}
                width={'20%'}
            >
                {
                    !isCappingDisabled &&
                    <Switch
                        disabled={isLoading || isNotEditable}
                        checked={isFinanced}
                        onChange={() => {
                            setFeeStateWithUpdate({is_capped: !feeState.is_capped})
                        }}
                    />
                }

            </TableCell>

            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={'60%'}
            >
                <CustomCurrencyInput
                    onChange={(value) => setFeeStateWithUpdate({amount: value}, false)}
                    className={classnames('payment-row_value custom-fee-input', {
                        mobileBlue: isTabletOrMobile && isFinanced,
                        loading: isLoading
                    })}
                    prefix="$"
                    value={feeState.amount}
                    key={fee.Id}
                    allowNull={true}
                    disabled={isEditingDisabled || isNotEditable}
                    InputProps={isTabletOrMobile ? {} : undefined}
                />
            </TableCell>
        </TableRow>
    )
}